import React from "react";
import Router from "./routes"; 

function App() {
  return (
    <div className="App">
      <Router />
    </div>
  );
}

export default App;
